import moment from "moment";
export default {
  methods: {
    valueFormatter: function(value, key, item) {
      //console.log("valueFormatter", value, key, item);
      "this is a longish string of text".replace(/^(.{11}[^\s]*).*/, "$1");
      return `${value}`
    },
    stringFormatter: function(value, key, item) {
      if(value){
        if(value.length > 50){
          return `${value.substring(0, 50)}...`
        }
      }
      return `${value}`
    },
    fechaFormatter: function(value, key, item) {
      //console.log("fechaFormatter", value);
      return `${moment(value).format("DD MMM YYYY")}`
    },
    fechaHoraFormatter: function(value, key, item) {
      //console.log("fechaFormatter", value);
      return `${moment(value).format("DD MMM YYYY, HH:mm")}`
    },
    cargoFormatter: function(value, key, item) {
      //console.log("cargoFormatter", value);
      return `${value}`;
    },
    listaCargoPersonalFormatter: function(value, key, item) {
      //console.log("cargoFormatter", value);
      if((value.length - 1) > 0){
        return `${value[0]} ${value.length - 1}+`;
      }
      return `${value[0]}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/formatters.js